import React from "react";
import { Link } from "react-router-dom";

import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import "../scss/card.scss";

const CardHeader = ({ image }) => {
  console.log(`${process.env.REACT_APP_API_URI}/${image}`);
  const style = { backgroundImage: `url(${process.env.REACT_APP_API_URI}/${image})` };

  return <div style={style} className="card-header" />;
};

const CardBody = ({ id, price, title, text }) => {
  return (
    <div className="card-body">
      <p className="price">{price}€</p>

      <h2>{title}</h2>

      <p className="body-content">{text}</p>

      <button className="button-primary">
        <Link to={`/prestations/${id}-${title}`} className="find-more-link">
          <ChevronRightIcon />
          <span>En savoir plus</span>
        </Link>
      </button>
    </div>
  );
};

const Card = ({
  id,
  image,
  service,
  price,
  details,
  handler,
  pack,
  handlePack,
}) => {
  const onClick = () => {
    handlePack({id, name: service});
    handler();
  };

  return (
    <div
      className={`service-card ${handler ? " cursor-p" : ""} ${
        handler && pack === service ? " selected-pack" : ""
      } `}
      onClick={handler ? onClick : null}
    >
      <CardHeader image={image} />
      <CardBody id={id} price={price} title={service} text={details} />
    </div>
  );
};

export default Card;
